export default (state = [], action) => {
  switch (action.type) {
    case "SET_PAST_OCCUPANCIES":
      const past_occupancies = action.payload.occupancies.filter((occupancy) =>
        occupancy.moved_out_at !== null && moment(occupancy.moved_out_at).isSameOrBefore(moment())
      );
      return past_occupancies || [];
    default:
      return state;
  }
}
